import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "breadcrumb" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "current" }, "Dashboard")
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "heading-div dashboard" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Welcome to Saat.my Customer Portal")
], -1)
const _hoisted_3 = { class: "container-xxl" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12 col-md-12 mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card banner-image" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "assets/img/customer-portal/banner-image.jpg",
      alt: "Banner Image",
      width: "1200",
      height: "278"
    })
  ])
], -1)
const _hoisted_6 = { class: "col-lg-4 col-md-12 mb-4" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", { class: "card-title-small" }, "NEXT RENEWAL", -1)
const _hoisted_10 = { class: "card-title mb-0" }
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Owner:")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Vehicle Number:")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Current active policy:")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Expires on:")
], -1)
const _hoisted_16 = { class: "card-bottom" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn"
}, "RENEW NOW", -1)
const _hoisted_18 = {
  key: 0,
  class: "col-lg-4 col-md-12 mb-4"
}
const _hoisted_19 = { class: "card btm-cta" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "card-title-small" }, "ACTIVE"),
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title mb-0" }, "Quotation")
], -1)
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Insurance Type")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Date Inquired")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Id Number")
], -1)
const _hoisted_25 = { class: "link-div centered pos-btm" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("VIEW ALL")
const _hoisted_27 = { class: "col-lg-4 col-md-12 mb-4" }
const _hoisted_28 = { class: "card btm-cta" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "card-title-small" }, "PURCHASE HISTORY"),
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title mb-0" }, "COMPLETED ORDER")
], -1)
const _hoisted_30 = { class: "card-body" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = { class: "link-div centered pos-btm" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("VIEW ALL")
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "content-backdrop fade" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.firstOrder.vehicle_type) + " Insurance", 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("table", null, [
                _createElementVNode("tr", null, [
                  _hoisted_12,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.firstOrder.customer_name), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_13,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.firstOrder.vehicle_reg_no), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_14,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.firstOrder.insurance_company_name), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_15,
                  _createElementVNode("td", null, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatDatePeriod(_ctx.firstOrder.sum_insured_to)), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.expiry_days >= 0 ? _ctx.expiry_days + ' Days to Expiry ' : 'Unknown'), 1),
              _hoisted_17
            ])
          ])
        ]),
        (_ctx.quotation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("table", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_22,
                      _createElementVNode("td", null, [
                        _createElementVNode("p", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.quotation.cover_type), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_23,
                      _createElementVNode("td", null, [
                        _createElementVNode("p", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.formatDatePeriod(_ctx.quotation.quotation_sent_at)), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_24,
                      _createElementVNode("td", null, [
                        _createElementVNode("p", null, [
                          _createElementVNode("strong", null, "#" + _toDisplayString(_ctx.quotation.id), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_router_link, {
                      class: "btn",
                      to: { name: 'CustomerQuotation' }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_26
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("table", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (order, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: order.id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("p", null, _toDisplayString(index+1) + ".", 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, "#" + _toDisplayString(order.id), 1),
                        _hoisted_31,
                        _createTextVNode(" " + _toDisplayString(order.customer_name), 1),
                        _hoisted_32,
                        _createTextVNode(" " + _toDisplayString(order.vehicle_type) + " Insurance", 1),
                        _hoisted_33,
                        _createTextVNode(" Renewed on " + _toDisplayString(_ctx.formatDatePeriod(order.sum_insured_to)), 1)
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(order.status_label == 'Completed' ? 'status completed' : 'status pending')
                      }, _toDisplayString(order.status_label), 3)
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_router_link, {
                  class: "btn",
                  to: { name: 'CustomerPurchaseHistory' }
                }, {
                  default: _withCtx(() => [
                    _hoisted_35
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_36
  ], 64))
}